import { MenuMobile } from './components/menu-mobile.js';
import { NavTabs } from './components/nav-tabs.js';
import { NotificationBar } from './components/notification-bar.js';
import { ShareHandler } from './components/share-handle.js';
import { Modal } from './components/modal.js';
import { scroll_to } from './functions/scroll_to.js';

document.addEventListener('DOMContentLoaded', function() {
	window.polymath = window.polymath || {};
	window.polymath.modal = Modal();
	window.polymath.scroll_to = scroll_to;

	MenuMobile();
	NavTabs();
	/*
	NotificationBar();
	ShareHandler();
	*/
});